import Enum from './Enum';

export default new Enum({
  HOME: 'Casa',
  APAR: 'Apartamento',
  COMM: 'Comercial',
  LAND: 'Terreno',
});
